export default __webpack_public_path__ + "static/media/email.9674b736.svg";